import { inScopeAsString, PdsrValidationItem, rc2FlagAsString } from "./PdsrValidationItem";
import { validationItemUpdateModeAsString } from "../ValidationItemUpdateMode";
import { PdsrExportValidationItem } from "./PdsrExportValidationItem";
import { defaultDateFormatDDMMYYYYSeperatedBySlash, formatDateTo } from "../../../Utils/dates";

export class PdsrValidationItemMapper {
  static toExportPdsrValidationItem = (
    pdsrValidationItem: PdsrValidationItem
  ): PdsrExportValidationItem => {
    return {
      ...pdsrValidationItem,
      Rc2Flag: rc2FlagAsString.get(pdsrValidationItem.Rc2Flag),
      InScope: inScopeAsString.get(pdsrValidationItem.InScope),
      UpdateMode: validationItemUpdateModeAsString.get(pdsrValidationItem.UpdateMode),
      LastModified: pdsrValidationItem.LastModifiedUser.concat(
        ", ",
        pdsrValidationItem.LastModifiedDateTime.toString()
      ),
      ImportDate: formatDateTo(
        pdsrValidationItem.ImportDate,
        defaultDateFormatDDMMYYYYSeperatedBySlash
      ),
      FirstCollectionDate: formatDateTo(
        pdsrValidationItem.FirstCollectionDate,
        defaultDateFormatDDMMYYYYSeperatedBySlash
      ),
      LastModifiedDateTime: formatDateTo(
        pdsrValidationItem.LastModifiedDateTime,
        defaultDateFormatDDMMYYYYSeperatedBySlash
      ),
    };
  };
}
